import { stats } from 'constants/stats';
import { useRevealGroup } from 'hooks/useReveal';
import './Stats.css';
import { useLanguage } from 'hooks/useLanguage';

/**
 * Показники організації — ADR-0007.
 *
 * Значення беруться з constants/stats.js. Незаповнені (null) виводяться прочерком,
 * і це навмисно помітно. Якщо заповнено менше двох показників, блок не рендериться:
 * рядок з одним числом і трьома прочерками виглядав би зламаним.
 */
export default function Stats() {
  const language = useLanguage();
  const listRef = useRevealGroup('.stat');

  const filledCount = stats.filter((item) => item.value !== null && item.value !== undefined).length;
  if (filledCount < 2) return null;

  return (
    <section className='stats'>
      <div className='container'>
        <dl className='stats-list' ref={listRef}>
          {stats.map((item) => (
            <div className='stat' key={item.labelUa}>
              <dt className='stat-value tnum'>{item.value ?? '-'}</dt>
              <dd className='stat-label'>{language === 'en' ? item.labelEn : item.labelUa}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
